

/// <reference path="InvitationRule.ts" />

// Generated class GenericEventInvitationRule_ManagedObject

class GenericEventInvitationRule_ManagedObject extends InvitationRule
{
}
